<template>
  <div>
    <div v-if="false" class="h-24 p-4 w-full bg-white mt-6">
      <p  class="text-center text-4xl text-green-500" >Current Filter: {{currentFilter}}</p>
    </div>
    <div class="m-10 flex min-h-screen justify-between flex-wrap" v-loading="loading"
         element-loading-text="Loading..."
         element-loading-spinner="el-icon-loading"
         element-loading-background="rgba(0, 0, 0, 0.8)">
      <StoresDetails />
      <ProductDetails />
      <Charts />
    </div>
  </div>

</template>

<script>
import StoresDetails from '../components/StoresDetails.vue';
import ProductDetails from '../components/ProductDetails.vue';
import Charts from '../components/Charts.vue';

export default {
  name: 'GeospatialAnalysis',
  data() {
    return {
      loading: false,
    };
  },
  components: {
    StoresDetails,
    ProductDetails,
    Charts,
  },
  computed: {
    currentFilter() {
      const data = this.$store.state.AIGeospatial.chart_filters;
      const keys = Object.keys(data);
      return data[keys[0]];
    },
  },
  async mounted() {
    this.setBreadCrumbs(this.$route.meta.breadCrumbs);
    try {
      this.loading = true;
      await this.$store.dispatch('AIGeospatial/fetchAllCountries');
      await this.$store.dispatch('AIGeospatial/fetchStores');
      await this.$store.dispatch('AIGeospatial/fetchProducts');
      await this.$store.dispatch('AIGeospatial/fetchSales');
    } catch (e) {
      this.loading = false;
    }

    this.loading = false;
  },
};
</script>

<style scoped>

</style>
